import { render, staticRenderFns } from "./WorkflowIndicators.vue?vue&type=template&id=20886aa0&scoped=true"
import script from "./WorkflowIndicators.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowIndicators.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowIndicators.vue?vue&type=style&index=0&id=20886aa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20886aa0",
  null
  
)

export default component.exports